import { vpPosition } from "../AppState";

export default function Counter({position, visible}: {position: vpPosition, visible: boolean}){
    const visibility = visible ? "visible" : "hidden";
    console.log("visible: ", visible, "visibility", visibility)
    const radius = 20;
    return (
        <div  style={{position: "fixed", left: position.x - radius, top: position.y - radius, visibility: visibility, 
            pointerEvents: "none"
        }}>
        <svg height={2 * radius} width={2*radius} viewBox={`0 0 ${2*radius} ${2*radius}`} >
            <circle className="counter"
            r={radius}
            cx={radius}
            cy={radius}
            />
        </svg>
        </div>
    )
}